export const UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS = {
	DEGRADED: 10,
	BLOCKING: 25,
};
